import { Box } from '@mui/material';
import React, { useState } from 'react';
import KanbanCardDetailsAndCommentsSection from '../KanbanCardDetailsAndCommentsSection';
import KanbanCardTabs from '../KanbanCardTabs';
import KanbanCardTasksSection from '../KanbanCardTasksSection';

export default function KanbanDetails({ card, priorities, cardTags, assigneds }) {
  const [tabView, setTabView] = useState(0);

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        maxHeight: `calc(100% - 0px )`,
        flexDirection: 'column',
        gap: (theme) => theme.spacing(3),
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#212b3661' : '#ffffff'),
        //     borderRadius: theme => theme.shape.borderRadius,
        boxShadow: (theme) => theme.shadows[3],
      }}
    >
      <KanbanCardTabs value={tabView} onChange={setTabView} />
      {tabView === 0 && <Box>
        <KanbanCardDetailsAndCommentsSection card={card} priorities={priorities} cardTags={cardTags} assigneds={assigneds} />
      </Box>
      }
      {tabView === 1 && (
        <Box sx={{ padding: (theme) => theme.spacing(3, 2.5, 5), gap: (theme) => theme.spacing(3) }}>
          <KanbanCardTasksSection card={card} assigneds={assigneds} />
        </Box>
      )}
    </Box>
  );
}
